import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import { forwardRef } from 'react';

const Button = forwardRef<HTMLButtonElement, MuiButtonProps>((props, ref) => {
  return (
    <MuiButton
      ref={ref}
      disableRipple
      variant="contained"
      color="primary"
      size="small"
      sx={{ textTransform: 'none' }}
      {...props}
    />
  );
});

Button.displayName = 'Button';

export default Button;
